module.exports = __webpack_public_path__ + "img/2025-0327-01-01.fe09377f.png";